import { _ as _asyncToGenerator, r as regenerator } from '../../index-33ee6c9f.js';
import { _ as _createClass, a as _classCallCheck } from '../../createClass-70c51ca1.js';
import { _ as _defineProperty } from '../../defineProperty-377d5a7f.js';
import React from 'react';
import AnalyticsService from '@picsart/rc/services/analytics';
import getBrowserVersion from '../../getBrowserVersion/index.js';
import getBrowserName from '../../getBrowserName/index.js';
import getDevice from '../../getDevice/index.js';
import isDev from '../../isDev/index.js';
import getOS from '../../getOsName/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var scopeType = /*#__PURE__*/function (scopeType) {
  scopeType["monetization"] = "monetization";
  scopeType["marketplace"] = "marketplace";
  scopeType["growth"] = "growth";
  scopeType["editor"] = "editor";
  scopeType["other"] = "other";
  return scopeType;
}({});
var bugsnagStagesEnum = /*#__PURE__*/function (bugsnagStagesEnum) {
  bugsnagStagesEnum["preproduction"] = "preproduction";
  bugsnagStagesEnum["development"] = "development";
  bugsnagStagesEnum["per-branch"] = "per-branch";
  bugsnagStagesEnum["production"] = "production";
  bugsnagStagesEnum["undefined_stage"] = "undefined_stage";
  return bugsnagStagesEnum;
}({});
var excludedErrors = ['fbq is not defined', "can't find variable: fbq"];
var fierAnalyticsCrashWebEvent = function fierAnalyticsCrashWebEvent(_ref) {
  var _event$originalError, _event$device, _event$device2, _event$device3, _event$device4, _event$device5, _event$device6, _event$device7, _event$device8, _event$originalError2, _event$errors$;
  var appVersion = _ref.appVersion,
    project = _ref.project,
    scope = _ref.scope,
    releaseStage = _ref.releaseStage,
    event = _ref.event;
  var _getDevice = getDevice(),
    is_mobile = _getDevice.isMobile;
  if (excludedErrors.includes(event === null || event === void 0 || (_event$originalError = event.originalError) === null || _event$originalError === void 0 ? void 0 : _event$originalError.message)) {
    return undefined;
  }
  var analyticsData = {
    project_version: appVersion,
    device: {
      id: event === null || event === void 0 || (_event$device = event.device) === null || _event$device === void 0 ? void 0 : _event$device.id,
      locale: event === null || event === void 0 || (_event$device2 = event.device) === null || _event$device2 === void 0 ? void 0 : _event$device2.locale,
      orientation: event === null || event === void 0 || (_event$device3 = event.device) === null || _event$device3 === void 0 ? void 0 : _event$device3.orientation,
      time: event === null || event === void 0 || (_event$device4 = event.device) === null || _event$device4 === void 0 ? void 0 : _event$device4.time,
      userAgent: event === null || event === void 0 || (_event$device5 = event.device) === null || _event$device5 === void 0 ? void 0 : _event$device5.userAgent,
      browserName: getBrowserName(event === null || event === void 0 || (_event$device6 = event.device) === null || _event$device6 === void 0 || (_event$device6 = _event$device6.userAgent) === null || _event$device6 === void 0 ? void 0 : _event$device6.toLowerCase()),
      browserVersion: getBrowserVersion(event === null || event === void 0 || (_event$device7 = event.device) === null || _event$device7 === void 0 ? void 0 : _event$device7.userAgent),
      osName: getOS(event === null || event === void 0 || (_event$device8 = event.device) === null || _event$device8 === void 0 ? void 0 : _event$device8.userAgent)
    },
    scope: scope,
    project: project,
    stage: releaseStage === null || releaseStage === void 0 ? void 0 : releaseStage.replace('-', '_'),
    url: event === null || event === void 0 ? void 0 : event.request,
    is_mobile: is_mobile,
    stackTrace: event === null || event === void 0 ? void 0 : event.originalError,
    crash_message: event === null || event === void 0 || (_event$originalError2 = event.originalError) === null || _event$originalError2 === void 0 ? void 0 : _event$originalError2.message,
    error_type: (event === null || event === void 0 || (_event$errors$ = event.errors[0]) === null || _event$errors$ === void 0 ? void 0 : _event$errors$.errorClass) || 'UnknownError',
    unhandled: event === null || event === void 0 ? void 0 : event.unhandled
  };
  try {
    AnalyticsService === null || AnalyticsService === void 0 || AnalyticsService.sendEvent('crash_web', analyticsData);
  } catch (_unused) {
    // ignore this
    // eslint-disable-next-line no-console
    console.log('CAN NOT SEND EVENT TO INTERNAL ANALYTICS', analyticsData.crash_message, analyticsData);
  }
};
var onErrorCallBack = function onErrorCallBack(_ref2) {
  var appVersion = _ref2.appVersion,
    project = _ref2.project,
    scope = _ref2.scope,
    releaseStage = _ref2.releaseStage;
  return function (event) {
    var _ErrorLogger$resetEve, _window$localStorage$, _window;
    // TODO:: remove this method after checking discarded events
    (_ErrorLogger$resetEve = ErrorLogger.resetEventCount) === null || _ErrorLogger$resetEve === void 0 || _ErrorLogger$resetEve.call(ErrorLogger);
    event === null || event === void 0 || event.addMetadata('sentToInternal', {
      paa_did: (_window$localStorage$ = (_window = window) === null || _window === void 0 || (_window = _window.localStorage) === null || _window === void 0 ? void 0 : _window.getItem('paa_did')) !== null && _window$localStorage$ !== void 0 ? _window$localStorage$ : ''
    });
    fierAnalyticsCrashWebEvent({
      appVersion: appVersion,
      project: project,
      scope: scope,
      releaseStage: releaseStage,
      event: event
    });
  };
};
var ErrorLogger = /*#__PURE__*/function () {
  function ErrorLogger() {
    _classCallCheck(this, ErrorLogger);
    _defineProperty(this, "bugsnagClient", null);
    _defineProperty(this, "bugsnagOnErrorConfig", void 0);
  }
  _createClass(ErrorLogger, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(props) {
        var _ref3, _ref3$releaseStage, releaseStage, _ref3$apiKey, apiKey, appVersion, _ref3$project, project, _ref3$scope, scope, metaData, _yield$import$default, _yield$import, _window$localStorage$2, _window2, Bugsnag, BugsnagPluginReact, getGeoZone;
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _ref3 = props !== null && props !== void 0 ? props : {}, _ref3$releaseStage = _ref3.releaseStage, releaseStage = _ref3$releaseStage === void 0 ? process.env.REACT_APP_BUGSNAG_ENV || bugsnagStagesEnum.undefined_stage : _ref3$releaseStage, _ref3$apiKey = _ref3.apiKey, apiKey = _ref3$apiKey === void 0 ? process.env.REACT_APP_BUGSNAG_API_KEY || null : _ref3$apiKey, appVersion = _ref3.appVersion, _ref3$project = _ref3.project, project = _ref3$project === void 0 ? 'undefined_project' : _ref3$project, _ref3$scope = _ref3.scope, scope = _ref3$scope === void 0 ? scopeType.other : _ref3$scope, metaData = _ref3.metaData;
              if (!apiKey) {
                _context.next = 25;
                break;
              }
              this.bugsnagOnErrorConfig = {
                appVersion: appVersion,
                project: project,
                scope: scope,
                releaseStage: releaseStage
              };
              _context.next = 5;
              return import('../../bugsnag-2ab9bef1.js').then(function (n) { return n.b; });
            case 5:
              Bugsnag = _context.sent["default"];
              _context.next = 8;
              return import('@bugsnag/plugin-react');
            case 8:
              BugsnagPluginReact = _context.sent["default"];
              _context.next = 11;
              return import('../getGeoZone/index.js');
            case 11:
              _context.t1 = _yield$import$default = (_yield$import = _context.sent)["default"];
              _context.t0 = _context.t1 === null;
              if (_context.t0) {
                _context.next = 15;
                break;
              }
              _context.t0 = _yield$import$default === void 0;
            case 15:
              if (!_context.t0) {
                _context.next = 19;
                break;
              }
              _context.t2 = void 0;
              _context.next = 20;
              break;
            case 19:
              _context.t2 = _yield$import$default.call(_yield$import);
            case 20:
              _context.next = 22;
              return _context.t2;
            case 22:
              getGeoZone = _context.sent;
              // TODO:: remove this method after checking discarded events
              ErrorLogger.resetEventCount = Bugsnag === null || Bugsnag === void 0 ? void 0 : Bugsnag.resetEventCount;
              this.bugsnagClient = Bugsnag.start({
                apiKey: apiKey,
                plugins: [new BugsnagPluginReact()],
                appVersion: appVersion,
                releaseStage: releaseStage,
                enabledReleaseStages: Object.keys(bugsnagStagesEnum),
                maxEvents: 100,
                maxBreadcrumbs: 100,
                onError: onErrorCallBack(this.bugsnagOnErrorConfig),
                metadata: _objectSpread({
                  scope: scope,
                  project: project,
                  paa_did: (_window$localStorage$2 = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.localStorage) === null || _window2 === void 0 ? void 0 : _window2.getItem('paa_did')) !== null && _window$localStorage$2 !== void 0 ? _window$localStorage$2 : '',
                  countryCode: getGeoZone === null || getGeoZone === void 0 ? void 0 : getGeoZone.country_code
                }, metaData)
              });
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init(_x) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "getErrorBoundary",
    value: function getErrorBoundary() {
      var bugsnagClient = this.bugsnagClient;
      return function getErrorBoundary(_ref4) {
        var children = _ref4.children;
        if (bugsnagClient) {
          var _bugsnagClient$getPlu;
          var ErrorBoundary = (_bugsnagClient$getPlu = bugsnagClient.getPlugin('react')) === null || _bugsnagClient$getPlu === void 0 ? void 0 : _bugsnagClient$getPlu.createErrorBoundary(React);
          return /*#__PURE__*/React.createElement(ErrorBoundary, null, children);
        }
        return children;
      };
    }
  }, {
    key: "trigger",
    value: function trigger(error) {
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'log';
      if (isDev) {
        // eslint-disable-next-line no-console
        console[status](error);
      }
      if (this.bugsnagClient && ['error', 'warn'].includes(status)) {
        this.bugsnagClient.notify(error, undefined, function (err) {
          if (err) {
            console.error("ANALYTICS_EVENT Failed to send report because of:\n".concat(err.stack));
          }
        });
      }
    }
  }, {
    key: "setUser",
    value: function setUser(user) {
      if (!this.bugsnagClient) return;
      this.bugsnagClient.setUser(String(user.id), user.email, user.name);
    }
  }, {
    key: "leaveBreadcrumb",
    value: function leaveBreadcrumb(message, metadata, type) {
      if (!this.bugsnagClient) return;
      this.bugsnagClient.leaveBreadcrumb(message, metadata, type);
    }
  }]);
  return ErrorLogger;
}();
// TODO:: remove this method after checking discarded events
_defineProperty(ErrorLogger, "resetEventCount", void 0);
var errorLogger = new ErrorLogger();

export { bugsnagStagesEnum, errorLogger as default, excludedErrors, scopeType };
//# sourceMappingURL=index.js.map
